import { render, staticRenderFns } from "./AddOrgModal.vue?vue&type=template&id=27763fb7&scoped=true&"
import script from "./AddOrgModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrgModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27763fb7",
  null
  
)

export default component.exports